// extracted by mini-css-extract-plugin
module.exports = {"BigRedButton":"XimiXurriButton_BigRedButton__373RR"};